<template>
    <el-drawer
        title="二级分类排序"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"        
        @close="close"
    >
        <div class="drawer-content">            
            <el-table
                :data="typeList"
                style="width: 100%"
                size="small"
                stripe
                border
                v-loading="dataLoading"
                row-key="id"
                class="sortable MT20"
            >
				<el-table-column prop="id" label="ID"></el-table-column>
				<el-table-column prop="name" label="分类"></el-table-column>
            </el-table>
            <div class="MT10 color-danger"><small><i class="el-icon-info"></i> 拖动排序，这里设置的顺序会影响乐迷端的展示顺序</small></div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
import Sortable from "sortablejs";
export default {
    components: {        
    },
    props:{
        type:{
            type:[Number,String],
            default:1
        }
    },
    data(){
        return{
            dataLoading: false,
            btnLoading:false,            
			drawerShow:false,
			typeList: [],
			ids:''
        }
    },
	
    methods:{
        close() {
            this.drawerShow = false;
        },
        show() {
            this.drawerShow = true;
			this.getTypeList()			
        },
        getTypeList() {
            this.dataLoading = true;
            this.$request({
                url: "/service/template/sortInfo",
                params: { id: this.type },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                       this.typeList = result
					   this.$nextTick(() => {
					       this.drag(); 
					       this.updateSort();
					   }); 
                    } else {
                        this.$message.error(msg || "获取数据失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取数据失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        drag(){
            const el = document.querySelectorAll('.sortable> .el-table__body-wrapper > table > tbody')[0];
            Sortable.create(el, {
                disabled: false, // 拖拽不可用? false 启用
                ghostClass: 'sortable-ghost', //拖拽样式
                animation: 150, // 拖拽延时，效果更好看
                onEnd: (e) => { // 拖拽结束时的触发
                    let arr = this.typeList; // 获取表数据
                    arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                    this.$nextTick(() => {
                        this.typeList = arr;
                        this.updateSort();
                    })
                },
            });
        },
        updateSort(){
           var _ids = ''
           _ids = this.typeList.map(item => item.id);
		   this.ids = _ids.toString()
        },
        async submitForm(){
            this.btnLoading = true;
            const response = await this.$request({
                url: '/service/template/updateSort',
                params: {
					id:this.type,
					ids:this.ids
				}
            });
            const {msg, state} = response.data;
            this.btnLoading = false;
            if (state != 1) return this.$message.error(msg);
			this.$message.success('操作成功！');
            this.close()
        }
    }
}
</script>